
import Vue from "vue";
import UpdateCreateExpense, {
    ExpenseEventData,
} from "@/components/UpdateCreateExpense.vue";
import { api } from "@/services/api";

export default Vue.extend({
    name: "Home",
    components: {
        UpdateCreateExpense,
    },
    methods: {
        async addExpense(expense: ExpenseEventData) {
            if (!expense.date) {
                alert("What's happening?");
                throw new Error("Date not populated");
            }
            const date = new Date(expense.date);
            await api.addExpense({
                amount: expense.amount,
                description: expense.description,
                date: date,
                tags: expense.tags,
                sensitive: expense.sensitive
            });
        },
    },
    computed: {},
});
